import { integrationApi } from '@api/integration/integration.api';

export const {
  useGetIntegrationSchemaQuery,
  useSaveIntegrationMutation,
  useAddIntegrationScopeMutation,
  useSaveIntegrationScopeMutation,
  useLoadIntegrationsQuery,
  useLazyLoadIntegrationsQuery,
  useUpdateIntegrationMapMutation,
  useUpdateIntegrationFieldsMutation,
  useUpdateIntegrationEndpointsMutation,
  useUpdateIntegrationSerialNumbersConfigMutation,
  useUpdateIntegrationConfigMutation,
  useDeleteIntegrationScopeMutation,
  useDeleteIntegrationMapMutation,
} = integrationApi;
